// removed by extract-text-webpack-plugin
module.exports = {"Base":"MoreArticles__Base-22AGO","Header":"MoreArticles__Header-3XMdF","ArticleHeader":"MoreArticles__ArticleHeader-5G698","ArticleRoll":"MoreArticles__ArticleRoll-2DGet","Link":"MoreArticles__Link-ByouO","Title":"MoreArticles__Title-3d4Mc","Article":"MoreArticles__Article-EUeIm","Title--sans":"MoreArticles__Title--sans-20z87 MoreArticles__Title-3d4Mc","Title--serif":"MoreArticles__Title--serif-3yuTB MoreArticles__Title-3d4Mc","Content":"MoreArticles__Content-3c8a4"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/MoreArticles/MoreArticles.css
 ** module id = 634
 ** module chunks = 0
 **/